/**
 * NativeWaves Org API v1
 *
 * Contact: support@nativewaves.com
 *
 * DO NOT EDIT THIS CLASS MANUALLY!
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class EnvironmentsApi extends runtime.BaseAPI {
    /**
     * Delete an environment and all its child resources.
     */
    async environmentsEnvironmentIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.environmentId === null ||
            requestParameters.environmentId === undefined) {
            throw new runtime.RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling environmentsEnvironmentIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/environments/{environmentId}`.replace(`{${'environmentId'}}`, String(requestParameters.environmentId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete an environment and all its child resources.
     */
    async environmentsEnvironmentIdDelete(requestParameters, initOverrides) {
        await this.environmentsEnvironmentIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get an environment.
     */
    async environmentsEnvironmentIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.environmentId === null ||
            requestParameters.environmentId === undefined) {
            throw new runtime.RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling environmentsEnvironmentIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/environments/{environmentId}`.replace(`{${'environmentId'}}`, String(requestParameters.environmentId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get an environment.
     */
    async environmentsEnvironmentIdGet(requestParameters, initOverrides) {
        const response = await this.environmentsEnvironmentIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of guests.
     */
    async environmentsEnvironmentIdGuestsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.environmentId === null ||
            requestParameters.environmentId === undefined) {
            throw new runtime.RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling environmentsEnvironmentIdGuestsGet.');
        }
        if (requestParameters.memberType === null ||
            requestParameters.memberType === undefined) {
            throw new runtime.RequiredError('memberType', 'Required parameter requestParameters.memberType was null or undefined when calling environmentsEnvironmentIdGuestsGet.');
        }
        const queryParameters = {};
        if (requestParameters.memberType !== undefined) {
            queryParameters['memberType'] = requestParameters.memberType;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/environments/{environmentId}/guests`.replace(`{${'environmentId'}}`, String(requestParameters.environmentId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of guests.
     */
    async environmentsEnvironmentIdGuestsGet(requestParameters, initOverrides) {
        const response = await this.environmentsEnvironmentIdGuestsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a guest.
     */
    async environmentsEnvironmentIdGuestsGuestIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.environmentId === null ||
            requestParameters.environmentId === undefined) {
            throw new runtime.RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling environmentsEnvironmentIdGuestsGuestIdGet.');
        }
        if (requestParameters.guestId === null ||
            requestParameters.guestId === undefined) {
            throw new runtime.RequiredError('guestId', 'Required parameter requestParameters.guestId was null or undefined when calling environmentsEnvironmentIdGuestsGuestIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/environments/{environmentId}/guests/{guestId}`
                .replace(`{${'environmentId'}}`, String(requestParameters.environmentId))
                .replace(`{${'guestId'}}`, String(requestParameters.guestId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a guest.
     */
    async environmentsEnvironmentIdGuestsGuestIdGet(requestParameters, initOverrides) {
        const response = await this.environmentsEnvironmentIdGuestsGuestIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of invitations.
     */
    async environmentsEnvironmentIdInvitationsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.environmentId === null ||
            requestParameters.environmentId === undefined) {
            throw new runtime.RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling environmentsEnvironmentIdInvitationsGet.');
        }
        const queryParameters = {};
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/environments/{environmentId}/invitations`.replace(`{${'environmentId'}}`, String(requestParameters.environmentId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of invitations.
     */
    async environmentsEnvironmentIdInvitationsGet(requestParameters, initOverrides) {
        const response = await this.environmentsEnvironmentIdInvitationsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete an invitation.
     */
    async environmentsEnvironmentIdInvitationsInvitationIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.environmentId === null ||
            requestParameters.environmentId === undefined) {
            throw new runtime.RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling environmentsEnvironmentIdInvitationsInvitationIdDelete.');
        }
        if (requestParameters.invitationId === null ||
            requestParameters.invitationId === undefined) {
            throw new runtime.RequiredError('invitationId', 'Required parameter requestParameters.invitationId was null or undefined when calling environmentsEnvironmentIdInvitationsInvitationIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/environments/{environmentId}/invitations/{invitationId}`
                .replace(`{${'environmentId'}}`, String(requestParameters.environmentId))
                .replace(`{${'invitationId'}}`, String(requestParameters.invitationId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete an invitation.
     */
    async environmentsEnvironmentIdInvitationsInvitationIdDelete(requestParameters, initOverrides) {
        await this.environmentsEnvironmentIdInvitationsInvitationIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get an invitation.
     */
    async environmentsEnvironmentIdInvitationsInvitationIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.environmentId === null ||
            requestParameters.environmentId === undefined) {
            throw new runtime.RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling environmentsEnvironmentIdInvitationsInvitationIdGet.');
        }
        if (requestParameters.invitationId === null ||
            requestParameters.invitationId === undefined) {
            throw new runtime.RequiredError('invitationId', 'Required parameter requestParameters.invitationId was null or undefined when calling environmentsEnvironmentIdInvitationsInvitationIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/environments/{environmentId}/invitations/{invitationId}`
                .replace(`{${'environmentId'}}`, String(requestParameters.environmentId))
                .replace(`{${'invitationId'}}`, String(requestParameters.invitationId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get an invitation.
     */
    async environmentsEnvironmentIdInvitationsInvitationIdGet(requestParameters, initOverrides) {
        const response = await this.environmentsEnvironmentIdInvitationsInvitationIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit an invitation.
     */
    async environmentsEnvironmentIdInvitationsInvitationIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.environmentId === null ||
            requestParameters.environmentId === undefined) {
            throw new runtime.RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling environmentsEnvironmentIdInvitationsInvitationIdPatch.');
        }
        if (requestParameters.invitationId === null ||
            requestParameters.invitationId === undefined) {
            throw new runtime.RequiredError('invitationId', 'Required parameter requestParameters.invitationId was null or undefined when calling environmentsEnvironmentIdInvitationsInvitationIdPatch.');
        }
        if (requestParameters.orgEnvironmentRoleRamInvitationEdit === null ||
            requestParameters.orgEnvironmentRoleRamInvitationEdit === undefined) {
            throw new runtime.RequiredError('orgEnvironmentRoleRamInvitationEdit', 'Required parameter requestParameters.orgEnvironmentRoleRamInvitationEdit was null or undefined when calling environmentsEnvironmentIdInvitationsInvitationIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/environments/{environmentId}/invitations/{invitationId}`
                .replace(`{${'environmentId'}}`, String(requestParameters.environmentId))
                .replace(`{${'invitationId'}}`, String(requestParameters.invitationId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.orgEnvironmentRoleRamInvitationEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit an invitation.
     */
    async environmentsEnvironmentIdInvitationsInvitationIdPatch(requestParameters, initOverrides) {
        const response = await this.environmentsEnvironmentIdInvitationsInvitationIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new invitation.
     */
    async environmentsEnvironmentIdInvitationsPostRaw(requestParameters, initOverrides) {
        if (requestParameters.environmentId === null ||
            requestParameters.environmentId === undefined) {
            throw new runtime.RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling environmentsEnvironmentIdInvitationsPost.');
        }
        if (requestParameters.orgEnvironmentRoleRamInvitationInsert === null ||
            requestParameters.orgEnvironmentRoleRamInvitationInsert === undefined) {
            throw new runtime.RequiredError('orgEnvironmentRoleRamInvitationInsert', 'Required parameter requestParameters.orgEnvironmentRoleRamInvitationInsert was null or undefined when calling environmentsEnvironmentIdInvitationsPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/environments/{environmentId}/invitations`.replace(`{${'environmentId'}}`, String(requestParameters.environmentId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.orgEnvironmentRoleRamInvitationInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new invitation.
     */
    async environmentsEnvironmentIdInvitationsPost(requestParameters, initOverrides) {
        const response = await this.environmentsEnvironmentIdInvitationsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of members.
     */
    async environmentsEnvironmentIdMembersGetRaw(requestParameters, initOverrides) {
        if (requestParameters.environmentId === null ||
            requestParameters.environmentId === undefined) {
            throw new runtime.RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling environmentsEnvironmentIdMembersGet.');
        }
        if (requestParameters.memberType === null ||
            requestParameters.memberType === undefined) {
            throw new runtime.RequiredError('memberType', 'Required parameter requestParameters.memberType was null or undefined when calling environmentsEnvironmentIdMembersGet.');
        }
        const queryParameters = {};
        if (requestParameters.memberType !== undefined) {
            queryParameters['memberType'] = requestParameters.memberType;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/environments/{environmentId}/members`.replace(`{${'environmentId'}}`, String(requestParameters.environmentId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of members.
     */
    async environmentsEnvironmentIdMembersGet(requestParameters, initOverrides) {
        const response = await this.environmentsEnvironmentIdMembersGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete a member.
     */
    async environmentsEnvironmentIdMembersMemberIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.environmentId === null ||
            requestParameters.environmentId === undefined) {
            throw new runtime.RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling environmentsEnvironmentIdMembersMemberIdDelete.');
        }
        if (requestParameters.memberId === null ||
            requestParameters.memberId === undefined) {
            throw new runtime.RequiredError('memberId', 'Required parameter requestParameters.memberId was null or undefined when calling environmentsEnvironmentIdMembersMemberIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/environments/{environmentId}/members/{memberId}`
                .replace(`{${'environmentId'}}`, String(requestParameters.environmentId))
                .replace(`{${'memberId'}}`, String(requestParameters.memberId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a member.
     */
    async environmentsEnvironmentIdMembersMemberIdDelete(requestParameters, initOverrides) {
        await this.environmentsEnvironmentIdMembersMemberIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get a member.
     */
    async environmentsEnvironmentIdMembersMemberIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.environmentId === null ||
            requestParameters.environmentId === undefined) {
            throw new runtime.RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling environmentsEnvironmentIdMembersMemberIdGet.');
        }
        if (requestParameters.memberId === null ||
            requestParameters.memberId === undefined) {
            throw new runtime.RequiredError('memberId', 'Required parameter requestParameters.memberId was null or undefined when calling environmentsEnvironmentIdMembersMemberIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/environments/{environmentId}/members/{memberId}`
                .replace(`{${'environmentId'}}`, String(requestParameters.environmentId))
                .replace(`{${'memberId'}}`, String(requestParameters.memberId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a member.
     */
    async environmentsEnvironmentIdMembersMemberIdGet(requestParameters, initOverrides) {
        const response = await this.environmentsEnvironmentIdMembersMemberIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit a member.
     */
    async environmentsEnvironmentIdMembersMemberIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.environmentId === null ||
            requestParameters.environmentId === undefined) {
            throw new runtime.RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling environmentsEnvironmentIdMembersMemberIdPatch.');
        }
        if (requestParameters.memberId === null ||
            requestParameters.memberId === undefined) {
            throw new runtime.RequiredError('memberId', 'Required parameter requestParameters.memberId was null or undefined when calling environmentsEnvironmentIdMembersMemberIdPatch.');
        }
        if (requestParameters.orgEnvironmentRoleRamMemberEdit === null ||
            requestParameters.orgEnvironmentRoleRamMemberEdit === undefined) {
            throw new runtime.RequiredError('orgEnvironmentRoleRamMemberEdit', 'Required parameter requestParameters.orgEnvironmentRoleRamMemberEdit was null or undefined when calling environmentsEnvironmentIdMembersMemberIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/environments/{environmentId}/members/{memberId}`
                .replace(`{${'environmentId'}}`, String(requestParameters.environmentId))
                .replace(`{${'memberId'}}`, String(requestParameters.memberId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.orgEnvironmentRoleRamMemberEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit a member.
     */
    async environmentsEnvironmentIdMembersMemberIdPatch(requestParameters, initOverrides) {
        const response = await this.environmentsEnvironmentIdMembersMemberIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new member.
     */
    async environmentsEnvironmentIdMembersPostRaw(requestParameters, initOverrides) {
        if (requestParameters.environmentId === null ||
            requestParameters.environmentId === undefined) {
            throw new runtime.RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling environmentsEnvironmentIdMembersPost.');
        }
        if (requestParameters.orgEnvironmentRoleRamMemberInsert === null ||
            requestParameters.orgEnvironmentRoleRamMemberInsert === undefined) {
            throw new runtime.RequiredError('orgEnvironmentRoleRamMemberInsert', 'Required parameter requestParameters.orgEnvironmentRoleRamMemberInsert was null or undefined when calling environmentsEnvironmentIdMembersPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/environments/{environmentId}/members`.replace(`{${'environmentId'}}`, String(requestParameters.environmentId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.orgEnvironmentRoleRamMemberInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new member.
     */
    async environmentsEnvironmentIdMembersPost(requestParameters, initOverrides) {
        const response = await this.environmentsEnvironmentIdMembersPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit an environment.
     */
    async environmentsEnvironmentIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.environmentId === null ||
            requestParameters.environmentId === undefined) {
            throw new runtime.RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling environmentsEnvironmentIdPatch.');
        }
        if (requestParameters.orgEnvironmentEdit === null ||
            requestParameters.orgEnvironmentEdit === undefined) {
            throw new runtime.RequiredError('orgEnvironmentEdit', 'Required parameter requestParameters.orgEnvironmentEdit was null or undefined when calling environmentsEnvironmentIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/environments/{environmentId}`.replace(`{${'environmentId'}}`, String(requestParameters.environmentId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.orgEnvironmentEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit an environment.
     */
    async environmentsEnvironmentIdPatch(requestParameters, initOverrides) {
        const response = await this.environmentsEnvironmentIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of environments.
     */
    async environmentsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null ||
            requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling environmentsGet.');
        }
        const queryParameters = {};
        if (requestParameters.organizationId !== undefined) {
            queryParameters['organizationId'] = requestParameters.organizationId;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.resourceState) {
            queryParameters['resourceState'] = requestParameters.resourceState;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/environments`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of environments.
     */
    async environmentsGet(requestParameters, initOverrides) {
        const response = await this.environmentsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new environment.
     */
    async environmentsPostRaw(requestParameters, initOverrides) {
        if (requestParameters.orgEnvironmentInsert === null ||
            requestParameters.orgEnvironmentInsert === undefined) {
            throw new runtime.RequiredError('orgEnvironmentInsert', 'Required parameter requestParameters.orgEnvironmentInsert was null or undefined when calling environmentsPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/environments`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.orgEnvironmentInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new environment.
     */
    async environmentsPost(requestParameters, initOverrides) {
        const response = await this.environmentsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const EnvironmentsEnvironmentIdGuestsGetMemberTypeEnum = {
    Team: 'Team',
    User: 'User',
};
/**
 * @export
 */
export const EnvironmentsEnvironmentIdMembersGetMemberTypeEnum = {
    Team: 'Team',
    User: 'User',
};
/**
 * @export
 */
export const EnvironmentsGetResourceStateEnum = {
    Active: 'ACTIVE',
    Disposed: 'DISPOSED',
    Deleted: 'DELETED',
};
//# sourceMappingURL=EnvironmentsApi.js.map